export const TeamList = [
    {
        Name: 'Cheung Chi Hung Jim',
        Role: 'Wet Lab Leader',
        Major: 'Molecular Biology & Biotechnology',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/jim.jpeg',
    },
    {
        Name: 'So Man Lok Anthony',
        Role: 'Wet Lab Researcher',
        Major: 'Biochemistry',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/so-man-lok-anthony.jpeg',
    },
    {
        Name: 'Lehan Hu',
        Role: 'Wet Lab Researcher',
        Major: 'Molecular Biology & Biotechnology (Cog Sci)',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/lehan.jpeg',
    },
    {
        Name: 'Tsoi Hoi Ching Gisela',
        Role: 'Wet Lab Researcher',
        Major: 'Biomedical Science',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/gisela.jpeg',
    },
    {
        Name: 'Yin Cheng Clancy',
        Role: 'Wet Lab Researcher',
        Major: 'Biochemistry',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/clancy.jpeg',
    },
    {
        Name: 'Wong King Chung Cyrus',
        Role: 'Dry Lab Leader',
        Major: 'Molecular Biology & Biotechnology (Comp Sci)',
        Department: 'Dry Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/cyrus.jpeg',
    },
    {
        Name: 'Lin Aijing Jean',
        Role: 'Dry Lab Researcher & Wet Lab Researcher',
        Major: 'Biomedical Engineering',
        Department: 'Dry Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/20230306135321-img-2913.jpeg',
    },
    {
        Name: 'Siddhant Ningoo',
        Role: 'Dry Lab Researcher',
        Major: 'Computer Science; Information Systems',
        Department: 'Dry Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/sid.jpeg',
    },
    {
        Name: 'Chong Wing Lam Bernard',
        Role: 'Dry Lab Researcher',
        Major: 'Molecular Biology & Biotechnology; Finance',
        Department: 'Dry Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/bernard.jpeg',
    },
    {
        Name: 'Sze Tsz Yan Anna',
        Role: 'Science Communication Leader',
        Major: 'Nursing',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/anna.jpeg',
    },
    {
        Name: 'Geng Yirong Erica',
        Role: 'Science Communication & Wet Lab Researcher',
        Major: 'Molecular Biology & Biotechnology',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/erica-geng-yirong.jpeg',
    },
    {
        Name: 'Lam Wing Hei Renee',
        Role: 'Science Communication',
        Major: 'MBBS',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/renee-lam.jpeg',
    },
    {
        Name: 'Chiu San Bo Duncan',
        Role: 'Science Communication',
        Major: 'Molecular Biology & Biotechnology',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/img-7016.jpeg',
    },
    {
        Name: 'Zhou Polly',
        Role: 'Science Communication',
        Major: 'Molecular Biology & Biotechnology',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/polly-photo.jpeg',
    },

]
export const InstructorList = [
    {
        Name: 'Vicera Christian Nelson Tejedor',
        Role: 'Instructor',
        Major: '',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/chris.jpeg',

    },
    {
        Name: 'Ng Tsz Chun Kenneth',
        Role: 'Instructor',
        Major: '',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/kenneth.jpeg',

    },
]

export const AdvisorList = [
    {
        Name: 'Lim Xin Yue Rita',
        Role: 'Advisor',
        Major: '',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/rita.jpeg',

    },
    {
        Name: 'Kazi Sunanas Utsha',
        Role: 'Advisor',
        Major: '',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/sunanas.jpeg',

    },
    {
        Name: 'Ananda Natarajan Jegadishwar',
        Role: 'Advisor',
        Major: '',
        Department: 'Wet Lab & Dry Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/jegadish.jpeg',

    },
    {
        Name: 'Khan Sarah',
        Role: 'Advisor',
        Major: '',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/sarah-khan-igem-2023.jpeg',

    },
    {
        Name: 'Balasubramanian Sneha',
        Role: 'Advisor',
        Major: '',
        Department: 'Wet Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/sneha.jpeg',

    },
    {
        Name: 'Yuen Yi Pun Clara',
        Role: 'Advisor',
        Major: '',
        Department: 'Dry Lab',
        photo: 'https://static.igem.wiki/teams/4696/wiki/clara.jpeg',

    },
    {
        Name: 'Sabrina Lerskiatiphanich',
        Role: 'Advisor',
        Major: '',
        Department: 'Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/sabrina-lersk.jpeg',

    },
    {
        Name: 'Poon Hoikiu Kailee',
        Role: 'Advisor',
        Major: '',
        Department: 'Wet Lab & Sci Comm',
        photo: 'https://static.igem.wiki/teams/4696/wiki/kailee-poon.jpeg',

    },
    
]


export const PIList = [
    {
        Name: 'Dr. Sugimura, Rio Ryohichi',
        Role: 'Principal Investigator',
        Major: 'Assistant Professor',
        Department: ['School of Biomedical Sciences',<br/>,'HKU'],
        photo: 'https://static.igem.wiki/teams/4696/wiki/sugimura-rio.png',

    },
    {
        Name: 'Prof. Kevin K. M. Tsia',
        Role: 'Principal Investigator',
        Major: 'Professor',
        Department: ['Department of Electrical and Electronic Engineering', <br/> ,'HKU'],
        photo: 'https://static.igem.wiki/teams/4696/wiki/kevintsia.png',

    },
]
